"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachDiscountTheme = void 0;
function attachDiscountTheme(products) {
    let discountIds = [];
    let themeIndex;
    let i;
    products.forEach((product, index) => {
        if (product.discounts && product.discounts.length) {
            product.discounts.forEach((discount) => {
                i = discountIds.indexOf(discount.id);
                if (-1 == i) {
                    themeIndex = discountIds.push(discount.id);
                    discount.class = 'discount-theme-' + themeIndex;
                }
                else {
                    discount.class = 'discount-theme-' + (i + 1);
                }
            });
        }
    });
    return products;
}
exports.attachDiscountTheme = attachDiscountTheme;
